import React from 'react';
import { Navigate } from 'react-router-dom';
import { useBusinessAuth } from '../../contexts/BusinessAuthContext';

function BusinessProtectedRoute({ children }) {
  const { isAuthenticated, loading } = useBusinessAuth();

  if (loading) {
    return (
      <div style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        color: 'white',
        fontSize: '1.2rem'
      }}>
        Loading...
      </div>
    );
  }

  if (!isAuthenticated()) {
    return <Navigate to="/business/login" replace />;
  }

  return children;
}

export default BusinessProtectedRoute;
